module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"PageBranchList":{"breadcrumbs":{"index":"Prodejny {website}"},"heading":{"main":"Prodejny {website}"},"seo":{"description":"Prodejny a pobočky","keywords":"prodejny, pobočky, výdejní místa {website}","title":"Prodejny a pobočky"}}}}')
  delete Component.options._Ctor
}
